import { render, staticRenderFns } from "./UpdateOrgLocate.vue?vue&type=template&id=78a95ea4&"
import script from "./UpdateOrgLocate.vue?vue&type=script&lang=js&"
export * from "./UpdateOrgLocate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateOrgLocate.vue"
export default component.exports